import request from '@/utils/request'

export function index(params) {
    return request({
        url: 'visitors/guests',
        method: 'get',
        params: params
    })
}

export function inventory(params) {
    return request({
        url: 'visitors/guest/inventory',
        method: 'get',
        params: params
    })
}

export function show(id) {
    return request({
        url: `/visitors/guests/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: `visitors/guests`,
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `visitors/guests/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(id) {
    return request({
        url: `visitors/guests/${id}`,
        method: 'delete',
    })
}

export function getVisitors(id) {
    return request({
        url: `/visitors/guest_visitors/${id}`,
        method: 'get'
    })
}
